import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInstagram,
  faTwitter,
  faTiktok,
  faCcVisa,
  faCcMastercard,
  faCcPaypal,
  faCcAmex,
  faStripe,
  faIdeal,
  faWhatsapp
} from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhone, faMapMarkerAlt, faBuilding } from '@fortawesome/free-solid-svg-icons';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const nextYear = currentYear + 1;

  return (
    <div>
      <footer className="bg-gray-900 text-white py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-left">
              <div className="flex items-center mb-4">
                <img
                  src={require('../assets/images/logowithoutlogo.png')}
                  alt="Asclepius Logo"
                  className="h-10 w-10 rounded-full object-cover mr-3"
                />
                <span className="text-2xl font-bold text-white brand-text">Asclepius Shilajit</span>
              </div>
              <p className="text-gray-300 mb-6">
                Unleashing nature's pure power <br />
                Premium Shilajit and herbs crafted to elevate your 
                body, mind, and spirit.
              </p>

              <div className="flex space-x-4 mb-6">
                <a href="https://www.instagram.com/asclepius_shilajit" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">
                  <FontAwesomeIcon icon={faInstagram} size="lg" />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">
                  <FontAwesomeIcon icon={faTwitter} size="lg" />
                </a>
                <a href="https://www.tiktok.com/@asclepiusshilajit" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">
                  <FontAwesomeIcon icon={faTiktok} size="lg" />
                </a>
              </div>
            </div>

            <div className="text-left">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <h3 className="text-lg font-semibold mb-4 pb-1 border-b-2 border-gray-700 inline-block">Quick Links</h3>
                  <ul className="space-y-2 text-left">
                    <li>
                      <Link to="/" className="text-gray-300 hover:text-white">Home</Link>
                    </li>
                    <li>
                      <Link to="/products" className="text-gray-300 hover:text-white">Products</Link>
                    </li>
                    <li>
                      <Link to="/about" className="text-gray-300 hover:text-white">About Us</Link>
                    </li>
                    <li>
                      <Link to="/contact" className="text-gray-300 hover:text-white">Contact</Link>
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-semibold mb-4 pb-1 border-b-2 border-gray-700 inline-block">Policies</h3>
                  <ul className="space-y-2 text-left">
                    <li>
                      <Link to="/privacy-policy" className="text-gray-300 hover:text-white">Privacy Policy</Link>
                    </li>
                    <li>
                      <Link to="/terms-of-service" className="text-gray-300 hover:text-white">Terms of Service</Link>
                    </li>
                    <li>
                      <Link to="/shipping-policy" className="text-gray-300 hover:text-white">Shipping Policy</Link>
                    </li>
                    <li>
                      <Link to="/refund-policy" className="text-gray-300 hover:text-white">Return Policy</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="text-left">
              <div className="mb-6">
                <h3 className="text-lg font-semibold mb-4 pb-1 border-b-2 border-gray-700 inline-block">Contact Us</h3>
                <div className="space-y-3 text-left">
                  <p className="flex items-center text-gray-300">
                    <FontAwesomeIcon icon={faMapMarkerAlt} className="mr-3 text-gray-400" />
                    The Netherlands, Rotterdam De Damhouderstraat 41 3052NH
                  </p>
                  <p className="flex items-center text-gray-300">
                    <FontAwesomeIcon icon={faBuilding} className="mr-3 text-gray-400" />
                    KVK: 97472875
                  </p>
                  <p className="flex items-center text-gray-300">
                    <FontAwesomeIcon icon={faEnvelope} className="mr-3 text-gray-400" />
                    info@asclepius-shilajit.com
                  </p>
                  <p className="flex items-center text-gray-300">
                    <FontAwesomeIcon icon={faPhone} className="mr-3 text-gray-400" />
                    +31 6 57945978
                  </p>
                  <p className="flex items-center text-gray-300">
                    <FontAwesomeIcon icon={faWhatsapp} className="mr-3 text-gray-400" />
                    +31 6 57945978
                  </p>
                </div>
              </div>
            </div>

            <div className="text-left">
              <h3 className="text-lg font-semibold mb-4 pb-1 border-b-2 border-gray-700 inline-block">Disclaimer</h3>
              <p className="text-gray-300 text-sm text-left">
                This product is not a substitute for a varied, balanced diet and a healthy lifestyle.
                This product is not intended to diagnose, treat, cure, or prevent any disease.
                Consult a doctor before use if you are pregnant, breastfeeding, taking medication, or have any medical condition.
                Shilajit is under review under the EU Novel Food Regulation (EU) 2015/2283. Legal status may vary.
                Do not exceed the recommended daily dose.
                Not suitable for persons under 18 years of age.
                Keep out of reach of children.
                Individual results may vary.
              </p>
            </div>
          </div>
        </div>
      </footer>

      <div className="bg-gray-900 text-gray-800 py-4 w-full shadow-sm">
        <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-start md:items-center text-left">
          <div className="text-sm text-gray-300">
            © {currentYear} - {nextYear} Asclepius Shilajit. All rights reserved.
          </div>
          <div className="flex space-x-4 text-gray-300 mt-2 md:mt-0">
            <FontAwesomeIcon icon={faCcVisa} size="lg" />
            <FontAwesomeIcon icon={faCcMastercard} size="lg" />
            <FontAwesomeIcon icon={faCcPaypal} size="lg" />
            <FontAwesomeIcon icon={faCcAmex} size="lg" />
            <FontAwesomeIcon icon={faStripe} size="lg" />
            <FontAwesomeIcon icon={faIdeal} size="lg" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
